/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType, lazy } from 'react'

export const lazyRechartsComponent = <
  T extends keyof typeof import('recharts')
>(
  componentName: T
) =>
  lazy(() =>
    import('recharts').then((module) => {
      const Component = module[componentName]
      if (!Component) {
        throw new Error(
          `Component ${componentName} does not exist in recharts.`
        )
      }
      return { default: Component as ComponentType<any> }
    })
  )
